export default "__VITE_ASSET__fXvCxjWI__"